import React, {Component} from 'react';

export default class Banner extends Component {

    render() {

        if(typeof this.props.src === 'undefined' || this.props.src === '') {
            return null;
        }

        return (
            <img
                src={this.props.src}
                style={{
                    display: 'block',
                    width: '100%',
                    height: 'auto',
                }}
                alt={''}
            />
        )
    }
}
